import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { TERMS_OF_USE, PRIVACY_POLICY } from '../../legal'

// Simple markdown-like rendering (reuses logic from LegalModal)
function renderContent(markdown: string) {
  const lines = markdown.split('\n')
  const elements: JSX.Element[] = []
  let key = 0

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]

    if (line.startsWith('# ')) {
      elements.push(<h1 key={key++}>{line.substring(2)}</h1>)
    } else if (line.startsWith('## ')) {
      elements.push(<h2 key={key++}>{line.substring(3)}</h2>)
    } else if (line.startsWith('### ')) {
      elements.push(<h3 key={key++}>{line.substring(4)}</h3>)
    } else if (line.startsWith('**') && line.endsWith('**')) {
      elements.push(<p key={key++}><strong>{line.slice(2, -2)}</strong></p>)
    } else if (line.startsWith('- ')) {
      const content = line.substring(2)
      const boldMatch = content.match(/\*\*(.+?)\*\*/)
      if (boldMatch) {
        const parts = content.split(/\*\*(.+?)\*\*/)
        elements.push(
          <li key={key++}>
            {parts.map((part, idx) =>
              idx % 2 === 1 ? <strong key={idx}>{part}</strong> : part
            )}
          </li>
        )
      } else {
        elements.push(<li key={key++}>{content}</li>)
      }
    } else if (line.trim()) {
      const parts = line.split(/\*\*(.+?)\*\*/)
      if (parts.length > 1) {
        elements.push(
          <p key={key++}>
            {parts.map((part, idx) =>
              idx % 2 === 1 ? <strong key={idx}>{part}</strong> : part
            )}
          </p>
        )
      } else {
        elements.push(<p key={key++}>{line}</p>)
      }
    }
  }

  return elements
}

export default function LegalPage() {
  const { type } = useParams<{ type: string }>()
  const { t, i18n } = useTranslation()

  const isTerms = type === 'terms'
  const title = isTerms ? t('legal.termsOfUse') : t('legal.privacyPolicy')
  const lang = i18n.language as keyof typeof TERMS_OF_USE
  const content = isTerms
    ? (TERMS_OF_USE[lang] || TERMS_OF_USE.en)
    : (PRIVACY_POLICY[lang] || PRIVACY_POLICY.en)

  useEffect(() => {
    document.title = `${title} | ${t('common.appName')}`
    window.scrollTo(0, 0)
  }, [title, t])

  return (
    <div className="container">
      <div className="legal-content" style={{ maxWidth: '800px', margin: '2rem auto', padding: '0 1rem' }}>
        {renderContent(content)}
      </div>
    </div>
  )
}
